import React, { useState, useRef, useEffect } from 'react'
import { Slide } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'
import ReactImageGallery from 'react-image-gallery'
import styles from './EventHero.module.scss'

export default function Slideshow({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [showFullScreen, setShowFullscreen] = useState(false)
  const [windowWidth, setWindowWidth] = useState(0)
  const imageRef = useRef()

  useEffect(() => {
    setCurrentIndex(images.length < 3 ? 0 : 1)
  }, [images])

  useEffect(() => {
    if (imageRef.current) {
      imageRef.current.fullScreen()
      imageRef.current.slideToIndex(currentIndex)
    }
  }, [showFullScreen])

  useEffect(() => {
    setWindowWidth(window.innerWidth)
  }, [])

  if (!images || images.length === 0) {
    return <div className={styles.containerWrapper}></div>
  }

  const getAlt = (image) => {
    if (image.alt && image.alt !== '') {
      return image.alt
    }

    if (image.title && image.title !== '') {
      return image.title
    }

    return ''
  }

  const toggleFullScreen = () => {
    setShowFullscreen(true)
  }

  const fullscreenIsToggled = (isFullscreen) =>
    !isFullscreen && setShowFullscreen(false)

  const formattedImages = images.map((image) => ({
    original: image.sizes['50-50'],
    fullscreen: image.sizes['2048x2048'],
    thumbnail: image.sizes.thumbnail,
    originalAlt: getAlt(image),
    thumbnailAlt: getAlt(image),
    loading: 'eager',
    thumbnailHeight: 92,
    thumbnailWidth: 92,
  }))

  const properties = {
    duration: 100000000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    indicators: false,
    transitionDuration: 500,
    easing: 'ease-out',
    canSwipe: windowWidth < 768,
    onChange: (previous, next) =>
      formattedImages.length < 3
        ? setCurrentIndex(next)
        : setCurrentIndex(next < formattedImages.length - 1 ? next + 1 : 0),
    nextArrow: (
      <div
        style={{
          display:
            formattedImages.length >= 3 ||
            windowWidth < 768 ||
            (formattedImages.length === 2 && currentIndex === 0)
              ? 'flex'
              : 'none',
        }}
        className={styles.nextArrow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="120px"
          viewBox="0 0 24 24"
          width="120px"
          className={`${styles.happensHover} ${styles.nextArrowIcon}`}
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
        </svg>
      </div>
    ),
    prevArrow: (
      <div
        style={{
          display:
            formattedImages.length >= 3 ||
            windowWidth < 768 ||
            (formattedImages.length === 2 && currentIndex === 1)
              ? 'flex'
              : 'none',
        }}
        className={styles.prevArrow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="120px"
          viewBox="0 0 24 24"
          width="120px"
          className={`${styles.happensHover} ${styles.prevArrowIcon}`}
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
        </svg>
      </div>
    ),
  }

  if (formattedImages.length === 1 && windowWidth <= 768) {
    return (
      <div className={styles.containerWrapper}>
        <div
          className={styles.card}
          style={{ backgroundImage: `url(${formattedImages[0].fullscreen})` }}
        >
          <div className={styles.cardWrapper} onClick={toggleFullScreen}></div>
        </div>
        {showFullScreen && (
          <div style={{ position: 'absolute', zIndex: '10000' }}>
            <ReactImageGallery
              items={formattedImages}
              ref={imageRef}
              onScreenChange={fullscreenIsToggled}
            />
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        <Slide {...properties}>
          {formattedImages.length < 3 && windowWidth >= 768 && (
            <div className="each-slide" key={0}>
              <div
                className={styles.card}
                style={{ backgroundColor: '#FFD1BD' }}
              ></div>
            </div>
          )}

          {formattedImages.map((slideImage, index) => (
            <div className="each-slide" key={slideImage.originalAlt + index}>
              <div
                className={styles.card}
                style={{ backgroundImage: `url(${slideImage.fullscreen})` }}
              >
                {currentIndex === index && (
                  <div
                    className={styles.cardWrapper}
                    onClick={toggleFullScreen}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="48px"
                      viewBox="0 0 24 24"
                      width="48px"
                      className={`${styles.happensHover} ${styles.fullscreenIcon}`}
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
                    </svg>
                  </div>
                )}
              </div>
            </div>
          ))}

          {formattedImages.length < 3 &&
            windowWidth >= 768 &&
            new Array([0, 0]).map((el, index) => {
              return (
                <div
                  className="each-slide"
                  key={formattedImages.length + index}
                >
                  <div
                    className={styles.card}
                    style={{ backgroundColor: '#FFD1BD' }}
                  ></div>
                </div>
              )
            })}
        </Slide>
      </div>
      {showFullScreen && (
        <div style={{ position: 'absolute', zIndex: '10000' }}>
          <ReactImageGallery
            items={formattedImages}
            ref={imageRef}
            onScreenChange={fullscreenIsToggled}
          />
        </div>
      )}
    </div>
  )
}
